import { useEffect, useState } from "react";
import { API } from "../../config/api";
import { useNavigate, useParams } from "react-router-dom";
import { GET, POST, PUT } from "../../utils/apicalls";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  notification,
  Row,
  Select,
  Spin,
} from "antd";
import { Container } from "react-bootstrap";
import moment from "moment";

import PageHeader from "../pageHeader/pageheader";
import Taskindex from "../task/taskindex";
import DataTaskTable from "../task/dataTaskTable";

function ViewProject() {
  const [ProjectData, setProjectData] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [selectdata, setselectData] = useState([]);
  const [selectClientData, setselectClientData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [TaskData, setTaskData] = useState<any>();
  const [meta, setMeta] = useState<any>({});
  const { id } = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(1500);
  useEffect(() => {
    getUserData();
  }, []);

  const getUserData = async () => {
    try {
      let api = API.PROJECT_GET_ONE + id;
      const Data: any = await GET(api, {});
      if (Data?.data) {
        const data = {
          ...Data.data,
          startDate: Data.data.startDate ? moment(Data.data.startDate) : null,
          endDate: Data.data.endDate ? moment(Data.data.endDate) : null,
        };
        setProjectData(data);
        form.setFieldsValue({
          ...Data.data,
          startDate: Data.data.startDate ? moment(Data.data.startDate) : null,
          endDate: Data.data.endDate ? moment(Data.data.endDate) : null,
        });
      }
    } catch (error) {
      console.log("Error fetching user data:", error);
    }
  };

  const onFinish = async (values: any) => {
    try {
      let obj = {
        projectId: values.projectId,
        projectType: values.projectType,
        projectName: values.projectName,
        startDate: values.startDate,
        endDate: values.endDate,
        clientid: values.clientid,
        status: values.status,
        description: values.description,
        assignedTo: values.assignedTo,
        hours: values.hours,
        minitues: values.minitues,
        priority: values.priority,
      };

      const api = API.UPDATE_PROJECT + id;
      const postRequest = await PUT(api, obj);

      if (postRequest) {
        notification.success({
          message: "project details updated successfully",
        });
        navigate(-1);
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    }
  };

  const fetchEmployee = async () => {
    try {
      setIsLoading(true);
      const url = API.EMPLOYEE_LISTING;
      const { data }: any = await GET(url, null);
      setselectData(data);
      console.log(data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchEmployee();
  }, []);

  const fetchClient = async () => {
    try {
      setIsLoading(true);
      const url = API.CLIENT_LISTING;
      const { data }: any = await GET(url, null);
      setselectClientData(data);
      console.log(data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchClient();
  }, []);

  useEffect(() => {
    viewTaskData();
  }, []);

  const viewTaskData = async () => {
    try {
      setIsLoading(true);
      let obj = {
        query: "string",
        page,
        take: pageSize,
        Projectid: Number(id),
      };
      const url = API.TASK_IN_PROJECT;
      const response: any = await POST(url, obj);
      setTaskData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch task data. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsOpen(true); // Open the modal
  };

  const submitHandlerTask = async (values: any) => {
    try {
      let obj = {
        Taskid: values.Taskid,
        TaskName: String(values.TaskName),
        startDates: values.startDates,
        endDates: values.endDates,
        Projectid: Number(id),
        assignedTo: ProjectData?.assignedTo || null,
        hourss: Number(values.hourss),
        clientid: ProjectData?.clientid || null,
        minituess: Number(values.minituess),
        prioritys: values.prioritys,
        descriptions: values.descriptions,
        status: values.status,
      };

      setIsLoading(true);
      const api = API.CREATE_TASK;
      const postRequest: any = await POST(api, obj);

      if (postRequest.status) {
        notification.success({ message: " created successfully!" });
        setIsLoading(false);
        setIsModalOpen(false);
        form.resetFields();
        navigate(-1);
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container>
      <PageHeader>
        {" "}
        <div className="header">
          {isOpen && (
            <Modal
              open={isOpen}
              onCancel={() => setIsOpen(false)}
              width={800}
              maskClosable={false}
              footer={false}
              title="create task"
            >
              <Taskindex
                onCancel={() => setIsOpen(false)}
                onFinish={(val: any) => submitHandlerTask(val)}
              />
            </Modal>
          )}

          <Button
            type="primary"
            onClick={showModal}
            style={{ marginRight: "10px" }}
          >
            Create task
          </Button>
        </div>{" "}
      </PageHeader>
      <Card className="user-details-card">
        <br />
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Row gutter={16}>
            <Col sm={6}>
              <Form.Item
                name="projectId"
                label=" projectId"
                rules={[{ required: true, message: "Enter projectId" }]}
              >
                <Input placeholder=" projectId" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="projectType"
                label="projectType"
                rules={[{ required: true, message: "Enter projectType" }]}
              >
                <Input placeholder="projectType" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="projectName"
                label="projectName"
                rules={[{ required: true, message: "Enter projectName" }]}
              >
                <Input placeholder="projectName" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="startDate" label="Start Date">
                <DatePicker />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="endDate" label="End Date">
                <DatePicker />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="description" label="description">
                <Input placeholder="description" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              {selectClientData && (
                <Form.Item
                  label="Client Name"
                  name="clientid"
                  style={{ marginBottom: 10 }}
                  rules={[{ required: true }]}
                >
                  <Select placeholder="Select an Client Name" size="large">
                    {selectClientData?.map((users: any, i: any) => (
                      <Select.Option key={users?.id} value={Number(users?.id)}>
                        {users?.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            </Col>
            <Col sm={6}>
              {selectdata && (
                <Form.Item
                  label="Employee Name"
                  name="assignedTo"
                  style={{ marginBottom: 10 }}
                  rules={[{ required: true }]}
                >
                  <Select placeholder="Select an employee" size="large">
                    {selectdata?.map((users: any, i: any) => (
                      <Select.Option key={users?.id} value={Number(users?.id)}>
                        {users?.fullName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            </Col>
            <Col sm={6}>
              <Form.Item
                name="status"
                label="Status"
                rules={[{ required: true, message: "Please select a status!" }]}
              >
                <Select placeholder="Select a status">
                  <Select.Option value="completed">Completed</Select.Option>
                  <Select.Option value="pending">Pending</Select.Option>
                  <Select.Option value="running">Running</Select.Option>
                  <Select.Option value="in-progress">In Progress</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            ;
            <Col sm={6}>
              <Form.Item name="hours" label="hours">
                <Input placeholder="hours" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="minitues" label="minitues">
                <Input placeholder="minitues" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="prioritys" label="priority">
                <Input placeholder="priority" />
              </Form.Item>
            </Col>
          </Row>

          {/* Buttons */}
          <Row className="mt-4" gutter={16}>
            <Col xs={24} sm={12} md={8}>
              <Button
                onClick={() => navigate("/Admin/Dashboard")}
                size="large"
                block
                className="cancel-button"
              >
                Cancel
              </Button>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Button
                size="large"
                type="primary"
                htmlType="submit"
                block
                className="update-button"
              >
                Update
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>

      <Card title="TASK DETAILS" style={{ textAlign: "center" }}>
        <Spin spinning={isLoading}>
          <DataTaskTable dataSource={TaskData} />
        </Spin>
      </Card>
    </Container>
  );
}

export default ViewProject;
